<template>
  <div class="transaction-row-base" :class="{'selected': isSelected, 'unselected': !isSelected,  'out-of-date': outOfDate }">
    <div class="transaction-date">
      <div v-if="hasActual">{{ formatDate(transactionDate) }}</div>
    </div>
    <div class="actual-amount" :class="{'bold': actualAmount > 0}">
      <decimal-number :value="actualAmount" />
      <span> ₪</span>
    </div>
    <div class="transaction-description">
      {{ transactionDescription }}
    </div>
    <div v-if="predictedAmount" class="predicted-amount">
      <decimal-number :value="predictedAmount" />
      <span> ₪</span>
    </div>
    <div v-if="customerComment" class="customer-comment-container">
      <span class="customer-comment">{{ customerComment }}</span>
    </div>
    <div class="option-btn" v-if="canEditEnvelope">
      <div class="options-wrapper">
        <img :src="require('@/assets/icons/vertical-three-dots.svg')"/>
      </div>
    </div>
  </div>
</template>

<script>
import DecimalNumber from '@/base-components/DecimalNumber';
import TransactionDisplayUtils from '../../TransactionDisplayUtils.vue';

export default {
  name: 'TransactionRowBase',
  mixins: [TransactionDisplayUtils],
  components: {
    DecimalNumber,
  },
  props: {
    actualAmount: {
      type: Number,
      required: false,
    },
    predictedAmount: {
      type: Number,
      required: false,
    },
    canEditEnvelope: {
      type: Boolean,
      required: false,
      default: true,
    },
    transactionDate: {
      type: String,
      required: false,
    },
    transactionDescription: {
      type: String,
      required: false,
    },
    isSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
    customerComment: {
      type: String,
      required: false,
    },
    outOfDate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasActual() {
      return this.actualAmount;
    },
  },
};
</script>
<style scoped lang="scss">
@import '~base-ui/src/scss/riseup-colors';
@import '~base-ui/src/scss/riseup-vars';
@import '../../../../../../../../../scss/mixins';

.transaction-row-base {
  color: $riseup_black;
  display: grid;
  @include cashflow-grid-columns;
  grid-template-rows: 25px 1fr;
  padding: 10px 17px 0 24px;
  cursor: pointer;

  .bold{
    font-weight: bold;
  }

  .transaction-date {
    grid-column: 1/2;
    grid-row: 1/2;
    font-size: 12px;
    padding-right: 7px;
  }

  .actual-amount{
    grid-column: 2/3;
    grid-row: 1/2;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .transaction-description {
    grid-column: 2/4;
    grid-row: 2/3;
    font-size: 12px;
    margin-bottom: 8px;
    line-height: 18px;
  }

  .predicted-amount {
    grid-column: 3/4;
    grid-row: 1/2;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .customer-comment-container {
    grid-column: 2/4;
    grid-row: 3/4;
    margin-bottom: 16px;

    .customer-comment {
      font-size: 12px;
      padding: 5px;
      background-color: $riseup_gray_5;
      border-radius: 4px;
    }
  }

  .option-btn {
    grid-column: 4/5;
    grid-row: 1/3;
    align-self: center;
    justify-self: center;
    display: flex;
    align-items: center;
    justify-content: center;

    .options-wrapper {
      padding-bottom: 10px;
    }
  }

  &.out-of-date {
    color: $riseup_gray_2;
  }
}

.unselected {
  background-color: $riseup_gray_4;
}

.selected{
  background-color: $riseup_gray_selected;
}

</style>
